const default_style = {
  name: "mxStylesheet",
  attributes: {},
  children: [
    {
      name: "add",
      attributes: {
        as: "defaultVertex",
      },
      children: [
        {
          name: "add",
          attributes: {
            as: "shape",
            value: "label",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "perimeter",
            value: "rectanglePerimeter",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "fontSize",
            value: "12",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "fontFamily",
            value: "Helvetica",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "align",
            value: "center",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "verticalAlign",
            value: "middle",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "fillColor",
            value: "#ffffff",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "strokeColor",
            value: "#000000",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "fontColor",
            value: "#000000",
          },
          children: [],
          value: "",
        },
      ],
      value: "",
    },
    {
      name: "add",
      attributes: {
        as: "text",
      },
      children: [
        {
          name: "add",
          attributes: {
            as: "fillColor",
            value: "none",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "gradientColor",
            value: "none",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "strokeColor",
            value: "none",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "align",
            value: "left",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "verticalAlign",
            value: "top",
          },
          children: [],
          value: "",
        },
      ],
      value: "",
    },
    {
      name: "add",
      attributes: {
        as: "edgeLabel",
        extend: "text",
      },
      children: [
        {
          name: "add",
          attributes: {
            as: "labelBackgroundColor",
            value: "#ffffff",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "fontSize",
            value: "11",
          },
          children: [],
          value: "",
        },
      ],
      value: "",
    },
    {
      name: "add",
      attributes: {
        as: "label",
      },
      children: [
        {
          name: "add",
          attributes: {
            as: "fontStyle",
            value: "1",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "align",
            value: "left",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "verticalAlign",
            value: "middle",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "spacing",
            value: "2",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "spacingLeft",
            value: "52",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "imageWidth",
            value: "42",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "imageHeight",
            value: "42",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "rounded",
            value: "1",
          },
          children: [],
          value: "",
        },
      ],
      value: "",
    },
    {
      name: "add",
      attributes: {
        as: "icon",
        extend: "label",
      },
      children: [
        {
          name: "add",
          attributes: {
            as: "align",
            value: "center",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "imageAlign",
            value: "center",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "verticalLabelPosition",
            value: "bottom",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "verticalAlign",
            value: "top",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "spacingTop",
            value: "4",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "labelBackgroundColor",
            value: "#ffffff",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "spacing",
            value: "0",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "spacingLeft",
            value: "0",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "spacingTop",
            value: "6",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "fontStyle",
            value: "0",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "imageWidth",
            value: "48",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "imageHeight",
            value: "48",
          },
          children: [],
          value: "",
        },
      ],
      value: "",
    },
    {
      name: "add",
      attributes: {
        as: "swimlane",
      },
      children: [
        {
          name: "add",
          attributes: {
            as: "shape",
            value: "swimlane",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "fontSize",
            value: "12",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "fontStyle",
            value: "1",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "startSize",
            value: "23",
          },
          children: [],
          value: "",
        },
      ],
      value: "",
    },
    {
      name: "add",
      attributes: {
        as: "group",
      },
      children: [
        {
          name: "add",
          attributes: {
            as: "verticalAlign",
            value: "top",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "fillColor",
            value: "none",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "strokeColor",
            value: "none",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "gradientColor",
            value: "none",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "pointerEvents",
            value: "0",
          },
          children: [],
          value: "",
        },
      ],
      value: "",
    },
    {
      name: "add",
      attributes: {
        as: "ellipse",
      },
      children: [
        {
          name: "add",
          attributes: {
            as: "shape",
            value: "ellipse",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "perimeter",
            value: "ellipsePerimeter",
          },
          children: [],
          value: "",
        },
      ],
      value: "",
    },
    {
      name: "add",
      attributes: {
        as: "rhombus",
      },
      children: [
        {
          name: "add",
          attributes: {
            as: "shape",
            value: "rhombus",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "perimeter",
            value: "rhombusPerimeter",
          },
          children: [],
          value: "",
        },
      ],
      value: "",
    },
    {
      name: "add",
      attributes: {
        as: "triangle",
      },
      children: [
        {
          name: "add",
          attributes: {
            as: "shape",
            value: "triangle",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "perimeter",
            value: "trianglePerimeter",
          },
          children: [],
          value: "",
        },
      ],
      value: "",
    },
    {
      name: "add",
      attributes: {
        as: "line",
      },
      children: [
        {
          name: "add",
          attributes: {
            as: "shape",
            value: "line",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "strokeWidth",
            value: "4",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "labelBackgroundColor",
            value: "#ffffff",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "verticalAlign",
            value: "top",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "spacingTop",
            value: "8",
          },
          children: [],
          value: "",
        },
      ],
      value: "",
    },
    {
      name: "add",
      attributes: {
        as: "image",
      },
      children: [
        {
          name: "add",
          attributes: {
            as: "shape",
            value: "image",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "labelBackgroundColor",
            value: "white",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "verticalAlign",
            value: "top",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "verticalLabelPosition",
            value: "bottom",
          },
          children: [],
          value: "",
        },
      ],
      value: "",
    },
    {
      name: "add",
      attributes: {
        as: "roundImage",
        extend: "image",
      },
      children: [
        {
          name: "add",
          attributes: {
            as: "perimeter",
            value: "ellipsePerimeter",
          },
          children: [],
          value: "",
        },
      ],
      value: "",
    },
    {
      name: "add",
      attributes: {
        as: "rhombusImage",
        extend: "image",
      },
      children: [
        {
          name: "add",
          attributes: {
            as: "perimeter",
            value: "rhombusPerimeter",
          },
          children: [],
          value: "",
        },
      ],
      value: "",
    },
    {
      name: "add",
      attributes: {
        as: "arrow",
      },
      children: [
        {
          name: "add",
          attributes: {
            as: "shape",
            value: "arrow",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "edgeStyle",
            value: "none",
          },
          children: [],
          value: "",
        },
        {
          name: "add",
          attributes: {
            as: "fillColor",
            value: "#ffffff",
          },
          children: [],
          value: "",
        },
      ],
      value: "",
    },
  ],
  value: "",
}

export default default_style
